/**
 * Klasa bazowa (Base DTO) dla wszystkich odpowiedzi API zasilających
 * komponenty tabelaryczne (DataGrid).
 * Standaryzuje obsługę paginacji, bezpieczeństwa oraz metadanych, podczas gdy
 * klasy pochodne rozszerzają ją o właściwy ładunek danych (np. tablicę `results`).
 */
export class GenericDgSearchResults {

  /** Całkowita liczba rekordów w bazie danych spełniających kryteria wyszukiwania.
   */
  public total: number;

  /** Token CSRF (Cross-Site Request Forgery).
   */
  public csrfToken: string;


  /** Uniwersalny licznik pomocniczy (Auxiliary Counter).
   * Pozwala na przesłanie dodatkowej statystyki bez łamania generycznego kontraktu.
   * Przykładowo umożliwia zliczenie liczby użytkowników Vetineo spiętych z KlinikąXP
   */
  public additionalCounter: number;

  constructor() {
  }
}
